// D:\Casticart\frontend\src\components\common\chat\fileValidation.js

import { isChatImageFile } from './chatImageCompatibility';
const FILE_TYPE_SPECS = [
  { ext: '.pdf', mimes: ['application/pdf'] },
  { ext: '.doc', mimes: ['application/msword'] },
  { ext: '.docx', mimes: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'] },
  { ext: '.xls', mimes: ['application/vnd.ms-excel', 'application/msexcel', 'application/x-msexcel'] },
  { ext: '.xlsx', mimes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] },
  { ext: '.csv', mimes: ['text/csv', 'application/csv', 'text/x-csv', 'application/vnd.ms-excel'] },
  { ext: '.txt', mimes: ['text/plain'] },
  { ext: '.ppt', mimes: ['application/vnd.ms-powerpoint', 'application/mspowerpoint'] },
  { ext: '.pptx', mimes: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'] },
  { ext: '.zip', mimes: ['application/zip', 'application/x-zip-compressed', 'multipart/x-zip'] },
  { ext: '.json', mimes: ['application/json', 'text/json'] },
  { ext: '.md', mimes: ['text/markdown', 'text/x-markdown'] },
  { ext: '.rtf', mimes: ['application/rtf', 'text/rtf'] },
  { ext: '.odt', mimes: ['application/vnd.oasis.opendocument.text'] },
  { ext: '.ods', mimes: ['application/vnd.oasis.opendocument.spreadsheet'] },
  { ext: '.odp', mimes: ['application/vnd.oasis.opendocument.presentation'] },
];
const FILE_MIME_SET = new Set(
  FILE_TYPE_SPECS.flatMap(({ mimes }) => mimes.map((mime) => mime.toLowerCase()))
);
const FILE_EXTENSION_SET = new Set(FILE_TYPE_SPECS.map(({ ext }) => ext.toLowerCase()));
export const CHAT_FILE_VALIDATION_ERROR_MESSAGE =
  '一般的な文書ファイル（PDF / Office / CSV / TXT / ZIP など）のみ対応しています';
export const CHAT_FILE_ACCEPT_ATTR = FILE_TYPE_SPECS.flatMap(({ ext, mimes }) => [ext, ...mimes]).join(',');

export const DEFAULTS = {
  maxImages: 5,
  maxFileBytes: 100 * 1024 * 1024, // 100MB
};

export function isImage(file) {
  return isChatImageFile(file);
}

export function isAllowedFile(file) {
  const mime = String(file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();
  const dotIndex = name.lastIndexOf('.');
  const ext = dotIndex >= 0 ? name.slice(dotIndex) : '';
  return FILE_MIME_SET.has(mime) || FILE_EXTENSION_SET.has(ext);
}

export function validateImages(files, opts = {}) {
  const maxImages = opts.maxImages ?? DEFAULTS.maxImages;
  const errors = [];
  const ok = [];

  const arr = Array.from(files || []);
  if (!arr.length) return { ok, errors };

  if (arr.length > maxImages) {
    errors.push(`画像は最大 ${maxImages} 枚までです`);
  }

  for (const f of arr.slice(0, maxImages)) {
    if (!isImage(f)) {
      errors.push(`画像は JPEG / PNG / WebP / AVIF / HEIC / HEIF に対応しています: ${f.name}`);
      continue;
    }
    ok.push(f);
  }
  return { ok, errors };
}

export function validateFile(file, opts = {}) {
  const maxBytes = opts.maxBytes ?? DEFAULTS.maxFileBytes;
  const errors = [];

  if (!file) return { ok: null, errors: ['ファイルが選択されていません'] };

  if (!isAllowedFile(file)) {
    errors.push(CHAT_FILE_VALIDATION_ERROR_MESSAGE);
  }
  if (file.size > maxBytes) {
    errors.push('ファイルサイズが大きすぎます（最大100MBまで）。Google Driveなどの共有リンクをご利用ください。');
  }
  return { ok: errors.length ? null : file, errors };
}
